import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/goodsDetail/:productId',
      name: 'GoodsDetail',
      component: () => import('@/views/shop/GoodsDetail')
    },
    {
      path: '/inviteShare',
      name: 'InviteShare',
      component: () => import('@/views/shop/InviteShare')
    },
    {
      path: '/reportShare',
      name: 'ReportShare',
      component: () => import('@/views/mini_watch/Report')
    },
    {
      path: '/newsShare',
      name: 'NewsShare',
      component: () => import('@/views/mini_watch/News')
    },
    {
      path: '/loveShare',
      name: 'LoveShare',
      component: () => import('@/views/mini_watch/Share')
    },
    // {
    //   path: '/',
    //   name: 'InviteShare',
    //   component: () => import('@/views/shop/InviteShare')
    // },
    {
      path: '/download',
      name: 'Download',
      component: () => import('@/views/download/Download')
    },
    {
      path: '/healthData/:userPhone',
      name: 'healthData',
      component: () => import('@/views/health/Health.vue')
    },
    {
      path: '/privateOne',
      name: 'PrivateOne',
      component: () => import('@/views/agreement/PrivateOne')
    },
    {
      path: '/privateTwo',
      name: 'PrivateTwo',
      component: () => import('@/views/agreement/PrivateTwo')
    },
    {
      path: '/privateThree',
      name: 'PrivateThree',
      component: () => import('@/views/agreement/PrivateThree')
    },
    {
      path: '/privateFour',
      name: 'PrivateFour',
      component: () => import('@/views/agreement/PrivateFour')
    },
    {
      path: '/privateFive',
      name: 'PrivateFive',
      component: () => import('@/views/agreement/PrivateFive')
    },
    {
      path: '/privateSix',
      name: 'PrivateSix',
      component: () => import('@/views/agreement/PrivateSix')
    },
    {
      path: '/privateSeven',
      name: 'PrivateSeven',
      component: () => import('@/views/agreement/PrivateSeven')
    },
    {
      path: '/sleep',
      name: 'Sleep',
      component: () => import('@/views/sleep/Sleep')
    },
    {
      path: '/graph',
      name: 'Graph',
      component: () => import('@/views/graph/Graph')
    },
    {
      path: '/graphHome',
      name: 'GraphHome',
      component: () => import('@/views/graph/GraphHome')
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js